import axios from "axios";

export default {
  getChats(context, payload) {
    const frmDta = new URLSearchParams();
    if (payload) {
      let url = "";
      if (payload.user_type == "client") {
        url = "support_chats_client";
      } else if (payload.user_type == "driver") {
        url = "support_chats_driver";
      } else {
        url = "support_chats_restaurant";
      }
      if (payload.keyword) {
        frmDta.append("keyword", payload.keyword);
      }
      if (payload.order_id) {
        frmDta.append("order_id", payload.order_id);
      }
      frmDta.append("user_type", payload.user_type);
      console.log(payload.user_type);
      frmDta.append("page", payload.paginations);
      if (payload.per_page) {
        frmDta.append("per_page", payload.per_page);
      }
      console.log(payload);
      axios.get(url, { params: frmDta }).then((res) => {
        context.commit(
          "setChats",
          res.data.data.map((el) => ({
            ago_time: el.ago_time,
            created_at: el.created_at,
            id: el.id,
            last_message: el.last_message,
            owner: el.owner,
            last_message_created_at: el.last_message_created_at,
            last_message_created: new Date(el.last_message_created).getTime(),
            is_read: el.is_read,
            last_message_status: el.last_message_status,
          }))
        );
        context.commit("set_lastPage", res.data.meta.last_page);
      });
    }
  },
};
